import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";


export default function FurnitureIndustrySolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("furniture.title")}</title>
        <meta name="keywords" content={t("furniture.keywords")} />
        <meta name="description" content={t("furniture.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#233c46]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate w-full h-[400px] overflow-hidden">
          <img
            src="/images/furniture-technician2.jpg"
            alt="Furniture service technician"
            className="absolute inset-0 h-full w-full object-cover object-[38%_25%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#0f2233]/90 via-[#0f2233]/70 to-transparent" />
          <div className="relative z-10 w-1200 h-full px-4 grid place-items-center text-center">
            <div>
              <h2
                className="text-white text-[30px] font-bold leading-snug"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("furniture.banner.title")}
              </h2>
              <span
                className="block h-[4px] w-[50px] bg-white mx-auto mt-3"
                data-aos="zoom-in"
                data-aos-delay="300"
              ></span>
              <p
                className="text-white/90 mt-5 text-base md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("furniture.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>
      <KnowledgeBaseMindMap
        rootLabel={t("furniture.knowledgeBase.rootLabel")}
        rootColor="#6366f1"
        treeTranslationKey="furniture.knowledgeBase.tree"
        i18nPrefix="furniture.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="furniture"
        images={{
          painPoints: "/images/furniture-technician-profile.jpg",
          solutions: "/images/furniture-technician3.jpg",
          cta: "/images/furniture-technician.jpg",
        }}
        imagesPos={{
          painPoints: "55% 20%",
        }}
      />
    </>
  );
}
